import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Tabs, Tab, Box, InputAdornment, Switch, Stepper, Step, StepLabel, Avatar, Autocomplete } from "@mui/material";
// components
import Page from "src/components/Page";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { useSelector } from "react-redux";
// import { getProductCategories } from "src/services/request";
import NavBack from "src/components/common/NavBack";
import { getAreas, getMerchantCategories } from "src/services/request";
import AddressPicker from "src/components/common/AddressPicker";
import { asyncRequest } from "src/services/network";
import Cascader from "src/components/cascader/Cascader";
import FormDialog from "src/components/common/FormDialog";
import SectionHeader from "src/components/section-header/SectionHeader";
import MyDatePicker from "src/components/MyDatePicker";
import dayjs from "dayjs";
// import banks from "src/data/banks.json";
import UserInfo from "src/components/common/UserInfo";
import TiejunPicker from "src/components/common/TiejunPicker";
import UserPicker from "src/components/common/UserPicker";
import BankPicker from "src/components/common/BankPicker";
import MccPicker from "src/components/common/MccPicker";

const steps = ["基础信息", "业务信息", "确认提交"];

// const bizTypes = ['餐饮', '电商平台', '零售', '食品生鲜', '咨询/娱乐票务', '房产中介', '宠物医院', '共享服务', '休闲娱乐/旅游服务', '游艺厅/KTV', '网吧', '院线影城', '演出赛事', '居民生活服务', '景区/酒店', '铁路客运', '机票/票务代理', '培训机构', '保健器械/医疗器械/非处方药品', '其他私立/民营医院/诊所', '其他缴费', '停车缴费', '私立/民营口腔及眼科、医疗美容医院/诊所']

export default function MerchantEdit({ item, onClose, onFinish, isApply }) {
  const { merchantCategories, areas, areaHierarchy, areaMap } = useSelector((state) => state.globalData);

  const navigate = useNavigate();
  const { mid } = item;
  const [category, setCategory] = useState({});
  const [detailObj, setDetailObj] = useState(item);
  const [detail, setDetail] = useState(item.detail);
  const [address, setAddress] = useState({
    address: item.address,
  });

  const [area, setArea] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [parent, setParent] = useState(item.parent || {});
  const [agent, setAgent] = useState(item.agent || {});
  const [form, setForm] = useState({
    mid: 0,
    platformCode: item.platformCode || 'huifu',
    businessRole:item.businessRole || 'ACQUIRING',
    type: item.type || 0,
    mobile: item.mobile || "",
    name: item.name || "",
    logo: item.logo || "",
    entrancePic: item.entrancePic || "",
    images: item.images || "",
    username: item.username || "",
    password: item.password || "",
    realname: item.realname || "",
    license: item.license || "",
    intro: item.intro || "",
    // 地理信息
    province: item.province || "",
    city: item.city || "",
    district: item.district || "",
    address: item.address || "",
    isZhiyin: item.isZhiyin || false,
    lng: item.lng || "",
    lat: item.lat || "",

    idCardNoSettle: item.idCardNoSettle || "",
    cardImgFrontSettle: item.cardImgFrontSettle || "",
    cardImgBackSettle: item.cardImgBackSettle || "",
    authEnturstPic: item.authEnturstPic || "",
    mobileSettle: item.mobileSettle || "",

    // 新增
    cardImgFront: item.cardImgFront || "",
    cardImgBack: item.cardImgBack || "",
    idCardNo: item.idCardNo || "",
    idCardAddress: item.idCardAddress || "",
    idCardStartDate: item.idCardStartDate || "",
    idCardEndDate: item.idCardEndDate || "",
    idCardEndDateLong: item.idCardEndDate == "长期" || false,
    licenseStartDate: item.licenseStartDate || "",
    licenseEndDate: item.licenseEndDate || "",
    licenseEndDateLong: item.licenseEndDate == "长期" || false,
    licenseNo: item.licenseNo || "",
    licenseRange: item.licenseRange || "",
    accountName: item.accountName || "",
    accountNumber: item.accountNumber || "",
    accountBank: item.accountBank || "",
    accountBankName: item.accountBankName || "",
    bankDistrictId: item.bankDistrictId || "",
    bankcard: item.bankcard || "",
    email: item.email || "",
    licenseName: item.licenseName || "",
    qualificationType: item.qualificationType || "",

    hfUid: item.hfUid || "",
    provinceId: item.provinceId || null,
    cityId: item.cityId || null,
    districtId: item.districtId || null,

    status: item.status || 1,
    order: item.order || 0,
    rangli: item.rangli || 20,
    discount: item.discount || 10,

    pid: item.pid || null,
    quUid: item.quUid || null,
    cardType: item.cardType != undefined ? item.cardType : 1,
  });

  useEffect(() => {
    getAreas();
    getMerchantCategories();
    checkPlatform()
  }, []);

  useEffect(() => {
    if (!merchantCategories.length || !item.categoryId) return;

    setCategory(merchantCategories.find((it) => it.id == item.categoryId) || {});
  }, [merchantCategories]);

  useEffect(() => {
    if (!areas) return;
    if (!form.provinceId) return;
    const province = areas.find((area) => area.id === form.provinceId);
    const city = areas.find((area) => area.id === form.cityId);
    const qu = areas.find((area) => area.id === form.districtId);
    // setArea(`${province.name}${city.name}${qu.name}`);
  }, [areas, form.districtId]);

  function handleIptChange(ki, val) {
    if(ki=='platformCode'){
      checkPlatform()
    }
    setForm({
      ...form,
      [ki]: val,
    });
  }
  function checkPlatform() {
    if(form.platformCode =='qdkf'){
      return true
    }else{
      return false
    }
  }
  function handleSelectBank() {
    BankPicker({
      onSelect(val) {
        handleIptChange("accountBank", val.name);
      },
    });
  }

  function handleSelectMcc() {
    MccPicker({
      onSelect(val) {
        handleIptChange("qualificationType", val.name);
      },
    });
  }

  async function handleSubmit() {
    if (!mid && !category.id) return alert("请选择分类");
    if (!mid && !address) return alert("请选择地址");

    const formData = {
      ...form,
      categoryId: category.id,
      ...address,
    };

    if (mid) {
      formData.mid = mid;

      delete formData.username;
      delete formData.password;
    }

    // 校验
    for (let k in formData) {
      if (typeof formData[k] == "string") {
        formData[k] = formData[k].trim();
      }

      switch (k) {
        case "idCardStartDate":
        case "idCardEndDate":
        case "licenseStartDate":
        case "licenseEndDate":
          formData[k] = dayjs(formData[k]).format("YYYY-MM-DD");
          break;
      }

      if (formData.idCardEndDateLong) {
        formData.idCardEndDate = "长期";
      }

      if (formData.licenseEndDateLong) {
        formData.licenseEndDate = "长期";
      }
    }
    const { data } = await asyncRequest({
      path: mid ? "/merchant/edit" : "/merchant/add",
      data: formData,
    });

    // navigate(-1, { replace: true });
    onFinish();
  }
  return (
    <FormDialog open onClose={onClose} onConfirm={handleSubmit} title={`${mid ? "汇付" : "添加"}商户信息`}>
      {/* <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper> */}

      <Box sx={{ width: 1000 }}>
        <FormItem title="商户类型" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.type}>
            {/* <FormControlLabel value={0} control={<Radio />} label="小微" onChange={(e) => handleIptChange("type", e.target.value)} />
            <FormControlLabel value={1} control={<Radio />} label="个体户" onChange={(e) => handleIptChange("type", e.target.value)} />
            <FormControlLabel value={2} control={<Radio />} label="企业" onChange={(e) => handleIptChange("type", e.target.value)} /> */}
            <FormControlLabel value={0} control={<Radio />} label="个体户" onChange={(e) => handleIptChange("type", e.target.value)} />
            <FormControlLabel value={1} control={<Radio />} label="企业" onChange={(e) => handleIptChange("type", e.target.value)} />
            <FormControlLabel value={2} control={<Radio />} label="小微" onChange={(e) => handleIptChange("type", e.target.value)} />
          </RadioGroup>
        </FormItem>

        {(form.type == 0 || form.type == 1) && (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <SectionHeader title="主体信息" />

            <Grid container>
              <Grid item md={6}>
                <FormItem title="主体名称" required>
                  <TextField fullWidth placeholder="请输入主体名称" autoComplete="off" id="licenseName" value={form.licenseName} size="small" onChange={(e) => handleIptChange("licenseName", e.target.value)} />
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem title="营业执照号" required>
                  <TextField fullWidth placeholder="请输入统一社会信用代码" autoComplete="off" id="licenseNo" value={form.licenseNo} size="small" onChange={(e) => handleIptChange("licenseNo", e.target.value)} />
                </FormItem>
              </Grid>

              <Grid item md={6}>
                <FormItem title="营业执照" required>
                  <Uploader images={form.license} onUploaded={(val) => handleIptChange("license", val)} />
                </FormItem>
              </Grid>

              <Grid item md={6}>
                <FormItem title="经营范围" required>
                  <TextField fullWidth multiline rows={2} placeholder="请输入经营范围" autoComplete="off" id="licenseRange" value={form.licenseRange} size="small" onChange={(e) => handleIptChange("licenseRange", e.target.value)} />
                </FormItem>
              </Grid>

              <Grid item md={6}>
                <FormItem title="执照有效期" required>
                  <MyDatePicker onChange={(v) => handleIptChange("licenseStartDate", v)} defaultValue={form.licenseStartDate} />
                </FormItem>
              </Grid>

              <Grid item md={6}>
                <FormItem title="执照截止日期" required>
                  <MyDatePicker
                    defaultValue={form.licenseEndDate}
                    onChange={(v) => {
                      handleIptChange("licenseEndDate", v);
                    }}
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={form.licenseEndDateLong}
                        onChange={(e) => {
                          handleIptChange("licenseEndDateLong", e.target.checked);
                        }}
                      />
                    }
                    label="长期"
                  />
                </FormItem>
              </Grid>
            </Grid>
          </Paper>
        )}

        <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
          <SectionHeader title="法人信息" />

          <Grid container>
            <Grid item md={6}>
              <FormItem title="法人姓名" required>
                <TextField fullWidth placeholder="法人姓名" autoComplete="off" id="realname" value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="法人手机号" required>
                <TextField fullWidth placeholder="法人手机号" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="身份证正面" required>
                <Uploader images={form.cardImgFront} onUploaded={(val) => handleIptChange("cardImgFront", val)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="身份证反面" required>
                <Uploader images={form.cardImgBack} onUploaded={(val) => handleIptChange("cardImgBack", val)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="身份证号" required>
                <TextField fullWidth placeholder="身份证号" autoComplete="off" id="idCardNo" value={form.idCardNo} size="small" onChange={(e) => handleIptChange("idCardNo", e.target.value)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="身份证地址" required>
                <TextField fullWidth placeholder="身份证地址" autoComplete="off" id="idCardAddress" value={form.idCardAddress} size="small" onChange={(e) => handleIptChange("idCardAddress", e.target.value)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="身份证有效期" required>
                <MyDatePicker onChange={(v) => handleIptChange("idCardStartDate", v)} defaultValue={form.idCardStartDate} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="身份证截止日期" required>
                <MyDatePicker
                  defaultValue={form.idCardEndDate}
                  onChange={(v) => {
                    // console.log(v);
                    handleIptChange("idCardEndDate", v);
                  }}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.idCardEndDateLong}
                      onChange={(e) => {
                        handleIptChange("idCardEndDateLong", e.target.checked);
                      }}
                    />
                  }
                  label="长期"
                />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="邮箱地址" required>
                <TextField fullWidth placeholder="邮箱地址" autoComplete="off" id="email" value={form.email} size="small" onChange={(e) => handleIptChange("email", e.target.value)} />
              </FormItem>
            </Grid>
          </Grid>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
          <SectionHeader title="经营信息" />

          <Grid container>
            <Grid item md={6}>
              <FormItem title="商户简称" required>
                <TextField fullWidth placeholder="请输入商户简称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="所属行业" required>
                {/* <Select value={form.qualificationType} onChange={(e) => handleIptChange("qualificationType", e.target.value)} style={{ width: 250, height: 44 }}>
                  {bizTypes.map((type, idx) => (
                    <MenuItem key={type} value={type} name={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select> */}
                <TextField fullWidth placeholder="请选择行业" autoComplete="off" id="qualificationType" value={form.qualificationType} size="small" onClick={handleSelectMcc} />
              </FormItem>
            </Grid>
            <Grid item md={6}>
              <FormItem title="是否直营" required>
                <Switch placeholder="请输入商户名称" autoComplete="off" id="isZhiyin" checked={form.isZhiyin} onChange={(e) => handleIptChange("isZhiyin", e.target.checked)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="商户logo" required>
                <Stack>
                  <Uploader images={form.logo} onUploaded={(val) => handleIptChange("logo", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：200x200
                  </Typography>
                </Stack>
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="店铺门头照" required>
                <Stack>
                  <Uploader images={form.entrancePic} onUploaded={(val) => handleIptChange("entrancePic", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：750x360
                  </Typography>
                </Stack>
              </FormItem>
            </Grid>
            <Grid item md={6}>
              <FormItem title="店铺内部照" required>
                <Stack>
                  <Uploader multiple images={form.images} onUploaded={(val) => handleIptChange("images", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：400x400
                  </Typography>
                </Stack>
              </FormItem>
            </Grid>
            <Grid item md={12}>
              <AddressPicker
                address={address.address}
                onChange={(v) => {
                  setAddress(v);
                }}
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
          <SectionHeader title="结算信息" />

          <Grid container>
            <Grid item md={6}>
              <FormItem title="账户类型" required>
                <Select value={form.cardType} onChange={(e) => handleIptChange("cardType", e.target.value)} style={{ width: 250, height: 44 }}>
                  {[0, 1, 2].map((type, idx) => (
                    <MenuItem key={type} value={type}>
                      {["对公账户", "对私法人账户", "对私非法人账户"][type]}
                    </MenuItem>
                  ))}
                </Select>
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="账户名称" required>
                <TextField fullWidth placeholder="小微和个体户是法人姓名，公司是营业执照名称" autoComplete="off" id="accountName" value={form.accountName} size="small" onChange={(e) => handleIptChange("accountName", e.target.value)} />
              </FormItem>
            </Grid>
            <Grid item md={6}>
              <FormItem title="账户号码" required>
                <TextField fullWidth placeholder="请输入账户号码" autoComplete="off" id="accountNumber" value={form.accountNumber} size="small" onChange={(e) => handleIptChange("accountNumber", e.target.value)} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="开户银行地区" required>
                <Cascader
                  options={areaHierarchy}
                  // defaultValue={`${areaMap[form.bankDistrictId] || ""}`}
                  kiLabel="name"
                  level={2}
                  onSelect={(v) => {
                    // console.log(v);
                    setForm({
                      ...form,
                      bankDistrictId: v[1].value,
                    });
                  }}
                />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="账户银行" required>
                {/* <Select value={form.accountBank} onChange={(e) => handleIptChange("accountBank", e.target.value)} style={{ width: 250, height: 44 }}>
                  {banks.map((bank, idx) => (
                    <MenuItem key={bank} value={bank} name={bank}>
                      {bank}
                    </MenuItem>
                  ))}
                </Select> */}

                <TextField fullWidth placeholder="请选择银行" autoComplete="off" id="accountBank" value={form.accountBank} size="small" onClick={handleSelectBank} />
              </FormItem>
            </Grid>
            {/*
            {form.accountBank == "其他银行" && (
              <>
                <Grid item md={6}>
                  <FormItem title="账户银行全称" required>
                    <TextField fullWidth placeholder="请输入账户银行全称" autoComplete="off" id="accountBankName" value={form.accountBankName} size="small" onChange={(e) => handleIptChange("accountBankName", e.target.value)} />
                  </FormItem>
                </Grid>
              </>
            )} */}

            <Grid item md={6}>
              <FormItem title="结算账户资料" required>
                <Uploader images={form.bankcard} onUploaded={(val) => handleIptChange("bankcard", val)} />
              </FormItem>
            </Grid>

            {form.cardType == 2 && (
              <>
                <Grid item md={6}>
                  <FormItem title="结算人身份证正面" required>
                    <Uploader images={form.cardImgFrontSettle} onUploaded={(val) => handleIptChange("cardImgFrontSettle", val)} />
                  </FormItem>
                </Grid>

                <Grid item md={6}>
                  <FormItem title="结算人身份证反面" required>
                    <Uploader images={form.cardImgBackSettle} onUploaded={(val) => handleIptChange("cardImgBackSettle", val)} />
                  </FormItem>
                </Grid>
                <Grid item md={6}>
                  <FormItem title="结算人身份证号" required>
                    <TextField fullWidth placeholder="结算人身份证号" autoComplete="off" id="idCardNoSettle" value={form.idCardNoSettle} size="small" onChange={(e) => handleIptChange("idCardNoSettle", e.target.value)} />
                  </FormItem>
                </Grid>

                <Grid item md={6}>
                  <FormItem title="结算人手机号" required>
                    <TextField fullWidth placeholder="结算人手机号" autoComplete="off" id="mobileSettle" value={form.mobileSettle} size="small" onChange={(e) => handleIptChange("mobileSettle", e.target.value)} />
                  </FormItem>
                </Grid>

                <Grid item md={6}>
                  <FormItem title="结算授权书" required>
                    <Uploader images={form.authEnturstPic} onUploaded={(val) => handleIptChange("authEnturstPic", val)} />
                  </FormItem>
                </Grid>
              </>
            )}
          </Grid>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
          <SectionHeader title="平台设置" />

          <Grid container>
            <Grid item md={6}>
              <FormItem title="商户分类" required>
                <Select value={category} onChange={(e) => setCategory(e.target.value)} style={{ width: 250, height: 44 }}>
                  {merchantCategories.map((category, idx) => (
                    <MenuItem key={category.id} value={category} name={category.name}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="汇付商户号">
                <TextField placeholder="请输入汇付商户号" autoComplete="off" id="hfUid" value={form.hfUid} size="small" onChange={(e) => handleIptChange("hfUid", e.target.value.trim())} />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="所属地区" required>
                <Cascader
                  options={areaHierarchy}
                  defaultValue={area}
                  kiLabel="name"
                  onSelect={(v) => {
                    setForm({
                      ...form,
                      provinceId: v[0].value,
                      cityId: v[1].value,
                      districtId: v[2].value,
                    });
                  }}
                />
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="让利百分比" required>
                <TextField
                  type="number"
                  placeholder="请输入让利百分比"
                  autoComplete="off"
                  id="rangli"
                  value={form.rangli}
                  size="small"
                  onChange={(e) => handleIptChange("rangli", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                  }}
                />
              </FormItem>
            </Grid>
            {/* <Grid item md={6}>
              <FormItem title="折扣">
                <TextField
                  type="number"
                  placeholder="请输入折扣，最低2折"
                  autoComplete="off"
                  id="discount"
                  value={form.discount}
                  size="small"
                  onChange={(e) => handleIptChange("discount", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">折</InputAdornment>,
                  }}
                />
              </FormItem>
            </Grid> */}
            <Grid item md={6}>
              <FormItem title="商户状态" required>
                <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
                  <FormControlLabel value={1} control={<Radio />} label="启用" onChange={(e) => handleIptChange("status", e.target.value)} />
                  <FormControlLabel value={2} control={<Radio />} label="停用" onChange={(e) => handleIptChange("status", e.target.value)} />
                </RadioGroup>
              </FormItem>
            </Grid>
            <Grid item md={6}>
              <FormItem title="推荐人" required>
                <Stack
                  onClick={() => {
                    if (mid) return;
                    TiejunPicker({
                      onSelect(v) {
                        // handleEdit(row.id, { categoryId: v.id });
                        // handleBindParent(row.mid, v);
                        handleIptChange("pid", v.uid);
                        setParent(v);
                        // setParent(v.user);
                      },
                    });
                  }}
                >
                  <UserInfo {...(parent.user || {})} enablePreview={false} />
                </Stack>
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="区代">
                <Stack
                  onClick={() => {
                    if (mid) return;
                    if (!form.districtId) return alert("请选择商户所在区");
                    UserPicker({
                      condition: {
                        districtId: form.districtId,
                      },
                      onSelect(v) {
                        // handleEdit(row.id, { categoryId: v.id });
                        handleIptChange("quUid", v.uid);
                        setAgent(v);
                      },
                    });
                  }}
                >
                  <UserInfo {...agent} enablePreview={false} />
                </Stack>
              </FormItem>
            </Grid>

            <Grid item md={6}>
              <FormItem title="排序">
                <TextField type="number" placeholder="请输入排序" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
              </FormItem>
            </Grid>
          </Grid>
        </Paper>

        {!mid && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <SectionHeader title="管理员信息" />

            <Grid container>
              <Grid item md={6}>
                <FormItem title="登陆账号" required>
                  <TextField fullWidth placeholder="登陆账号" autoComplete="off" id="username" value={form.username} size="small" onChange={(e) => handleIptChange("username", e.target.value)} />
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem title="登录密码" required>
                  <TextField fullWidth placeholder="登录密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
                </FormItem>
              </Grid>
            </Grid>
          </Paper>
        )}
      </Box>
    </FormDialog>
  );
}
